@if (!bvProductId) {
  <div class="empty-bv-rating-summary"></div>
}
@if (bvProductId) {
  @if (isSummary) {
    <div class="bv-rating-summary" data-bv-show="rating_summary" [attr.data-bv-product-id]="bvProductId"></div>
  }
  @if (isReviews) {
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <div class="bv-reviews" data-bv-show="reviews" [attr.data-bv-product-id]="bvProductId"></div>
        </div>
      </div>
    </div>
  }
  @if (isHighlights) {
    <div class="bv-review-highlights" data-bv-show="review_highlights" [attr.data-bv-product-id]="bvProductId"></div>
  }
  @if (isInline) {
    <div class="bv-inline-rating" data-bv-show="inline_rating" data-bv-seo="false" [attr.data-bv-product-id]="bvProductId"></div>
  }
}
